/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_Booking_CreditInputs */

const en_admin_dashboard_invoice_tags_booking_credit = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking Credits`)
};

const de_admin_dashboard_invoice_tags_booking_credit = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungsguthaben`)
};

const es_admin_dashboard_invoice_tags_booking_credit = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créditos de reserva`)
};

const fr_admin_dashboard_invoice_tags_booking_credit = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crédits de réservation`)
};

const it_admin_dashboard_invoice_tags_booking_credit = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crediti prenotazione`)
};

const pt_br2_admin_dashboard_invoice_tags_booking_credit = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créditos de reserva`)
};

const pl_admin_dashboard_invoice_tags_booking_credit = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredyty rezerwacyjne`)
};

const hu_admin_dashboard_invoice_tags_booking_credit = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalási kreditek`)
};

const ro_admin_dashboard_invoice_tags_booking_credit = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credite Rezervare`)
};

/**
* | output |
* | --- |
* | "Booking Credits" |
*
* @param {Admin_Dashboard_Invoice_Tags_Booking_CreditInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_booking_credit = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_Booking_CreditInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_Booking_CreditInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_booking_credit(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_booking_credit(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_booking_credit(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_booking_credit(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_booking_credit(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_booking_credit(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_booking_credit(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_booking_credit(inputs)
	return ro_admin_dashboard_invoice_tags_booking_credit(inputs)
});
export { admin_dashboard_invoice_tags_booking_credit as "admin.dashboard.invoice_tags.booking_credit" }